import React from 'react';
import { connect } from "react-redux";
import moment from "moment";

import JobBoardJobLogEntryTime from "./JobBoardJobLogEntryTime";
import {getJobLogEntries} from "../../utilities/job";

const JobDateOpened = (props) => {
  const {job} = props;

  const logEntries = getJobLogEntries(job);

  const reversed = [...logEntries].reverse();

  let currentActiveEntry = reversed.find((entry) => {
    return ((entry.type === "ChangeLeadType") || (entry.type === "ChangeJobStatus"))
  })
  if (!currentActiveEntry && ((logEntries.length === 1) || (logEntries.length && logEntries.every(entry => entry.type === "FreeText")))
    && logEntries[0].type && (logEntries[0].type.toLowerCase() === "freetext")) {
    currentActiveEntry = logEntries[0]; // case when job was created by the system(for example on customer create)
  }
  let lastActiveEntry = logEntries[0];

  const renderMainEntryTime = () => {
    if (!currentActiveEntry) {
      return null
    }
    if (currentActiveEntry.newStatus === "Completed" || currentActiveEntry.newStatus === "Dead Lead") {
      const entryTime = moment(currentActiveEntry.timestamp);
      const renderTime = entryTime.format('MM-DD-YYYY') + " @" + entryTime.format('HH:mm');
      if (currentActiveEntry.newStatus === "Completed") {
        return <div className="job-board-green">{renderTime}</div>
      } else if (currentActiveEntry.newStatus === "Dead Lead") {
        return <div className="job-board-red">{renderTime}</div>
      }
    }
    return <JobBoardJobLogEntryTime logEntries={logEntries} logEntry={currentActiveEntry}/>
  }

  return (
    <div className="job-board-col">
      <div className="job-board-items">
        {lastActiveEntry && currentActiveEntry && (logEntries.length !== 2 || logEntries[0].id !== 1) && (lastActiveEntry.timestamp !== currentActiveEntry.timestamp) ? (
          <div className="job-board-time--top">
            <JobBoardJobLogEntryTime logEntries={reversed} logEntry={lastActiveEntry}/>
          </div>
        ) : null}
        <div className={"job-board-time regular job-board-blue"}>
          {renderMainEntryTime()}
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = () => {
  return {

  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(JobDateOpened);
